<template>
  <ibox>
    <template slot="title">口コミ詳細</template>
    <template slot="body">
      <review-form :id="reviewId"></review-form>
    </template>
  </ibox>
</template>

<script>
import ReviewForm from '../../../components/company/review/Form.vue'

export default {
  data () {
    return {
      reviewId: this.$route.params.review_id
    }
  },
  components: {
    ReviewForm
  }
}
</script>




// WEBPACK FOOTER //
// Edit.vue?7d172dd1